import { TranslatorService } from '@services/translator/translator.service';
import { Injectable, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uniqBy } from 'lodash';

@Injectable()
export class MasterClienteHomeCreateProfileService {
  form: FormGroup;

  constructor(private formBuilder: FormBuilder,private translatorService:TranslatorService) {
    this.form = this.formBuilder.group({
      name: [null, [Validators.required]],
      description: [null, []],
    });
  }

  static emitirListProfiles = new EventEmitter<any>();
  roles: any = [];
  node: string;
  role: any = [];

  setRoles(roles, node) {
    roles.map(role => {
      role.typeNode = node;
      this.addRole(role);
    });
  }
  addRole(role) {
    this.role.push(role);
    this.checkDuplicateValues();
    this.groupRoles();
  }

  groupRoles() {
    const users = [];
    const roles = [];
    this.role.forEach(r => {
      if (r.typeNode == 'profile') {
        roles.push(r);
        this.roles['profile'] = roles;
      }

      if (r.typeNode == 'users') {
        users.push(r);
        this.roles['users'] = users;
      }
    });
    this.getUsersSelected();
    this.getRolesSelected();
    MasterClienteHomeCreateProfileService.emitirListProfiles.emit(this.roles);
  }

  checkDuplicateValues() {
    this.role = uniqBy(this.role, 'id');
  }

  getUsersSelected() {
    if (this.roles['users']) {
      return this.roles['users']
        .filter(user => user.checked == true)
        .map(e => e.id);
    }
  }

  getRolesSelected() {
    if (this.roles['profile']) {
      return this.roles['profile']
        .filter(prof => prof.checked == true)
        .map(e => e.id);
    }
  }

  getMessageProfileNameDuplicated(profileName: string): string {
    let profileNameDuplicatedStart,profileNameDuplicatedEnd:string;
    this.translatorService.getMessage('ProfileNameDuplicatedStart').subscribe(
      data=>profileNameDuplicatedStart=data
    )
    this.translatorService.getMessage('ProfileNameDuplicatedEnd').subscribe(
      data=>profileNameDuplicatedEnd=data
    )
    return profileNameDuplicatedStart+`"${profileName}" `+profileNameDuplicatedEnd;
  }
}
